// extracted by mini-css-extract-plugin
module.exports = {"Blacknav":"Blacknav_Blacknav__y64bg"};